import { AlpineComponent } from '@alpinejs/csp';

const Quote = (): AlpineComponent => ({
  visible: false,
  handleIntersect() {
    this.visible = true;
  },
  getClassName() {
    return this.visible ? 'quote--visible' : '';
  }
});

export default Quote;
